/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryParams, StringParam } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import SupserAdminDashboard from './SuperAdminDashboard';

export interface SuperAdminDashboardQueryProps extends IPaginationQueryParams {
    search?: string;
}

export type SuperAdminDashboardBasicProps = IHOCQueryProps<SuperAdminDashboardQueryProps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
    orderBy: 'created_at',
    orderDirection: OrderDirection.DESC,
});

const SuperAdminDashboardWithQueryParams = () => {
    const queryConfig = {
        ...DEFAULT_QUERY_PARAMS,
        search: StringParam,
    };

    return (
        <QueryParams config={queryConfig}>
            {(props: any) => {
                return <SupserAdminDashboard {...props} />;
            }}
        </QueryParams>
    );
};

export default SuperAdminDashboardWithQueryParams;
